"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBannerContainer = exports.ActionContainer = exports.IconTextContainer = exports.StyledBody = exports.StyledButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("../common/styles");
const styledBannerOptions = {
    shouldForwardProp: (propName) => {
        const doNotForward = [
            'type',
            'action1text',
            'action1',
            `useiconforaction1`,
            'action2text',
            'action2',
            'text'
        ];
        return !doNotForward.includes(propName.toLowerCase());
    }
};
exports.StyledButton = (0, styled_1.default)(button_1.default, styledBannerOptions) `
  padding-top: ${(props) => (props.useIconForAction1 ? '9px' : '7px')};
  padding-bottom: 8px;
  border: 0px;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  position: relative;

  svg {
    border: 2px ${(0, ui_theme_1.fromTheme)('border_style')} transparent;
    position: absolute;
    right: 12px;
    top: 6px;
  }

  &:focus {
    svg {
      border: 2px ${(0, ui_theme_1.fromTheme)('border_style')} ${(0, ui_theme_1.fromTheme)('color_link')};
      border-radius: 4px;
    }
  }

  &:focus,
  &:hover {
    color: transparent;
    background-color: transparent;
    border-color: transparent;
    text-decoration: underline;
  }
  &:disabled {
    color: transparent;
    background-color: transparent;
    border-color: transparent;
  }
`;
exports.StyledBody = styled_1.default.div `
  display: block;
  padding-left: ${(props) => (props.icon == undefined ? '0px' : '30px')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')}
    ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.IconTextContainer = styled_1.default.div `
  text-align: left;
  width: fit-content;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;
exports.ActionContainer = (0, styled_1.default)('div', styledBannerOptions) `
  ${(props) => {
    if (props.useIconForAction1) {
        return 'display: grid; grid-column: 2; align-items: start; margin-left: auto';
    }
    else {
        return 'display: flex; margin-left: auto; margin-top: auto;';
    }
}}
`;
exports.StyledBannerContainer = (0, styled_1.default)('div', styledBannerOptions) `
  display: ${(props) => props.visible ? (props.useIconForAction1 ? 'grid' : 'flex') : 'none'};
  flex-wrap: wrap;
  flex-grow: initial;
  overflow: auto;
  width: 100%;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')};
  border-color: ${(props) => (0, ui_theme_1.fromTheme)(styles_1.bannerTypeColorMap[props.type].border)(props)};

  a,
  a:visited {
    color: ${(0, ui_theme_1.fromTheme)('color_providermatch')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }

  background-color: ${(props) => (0, ui_theme_1.fromTheme)(styles_1.bannerTypeColorMap[props.type].background)(props)};
`;
//# sourceMappingURL=Banner.styles.js.map